// js
import React from 'react';
import PropTypes from 'prop-types';
import RollUpOverviewRowPPTX from './RollUpOverviewRowPPTX';


const RollUpOverviewAreaPPTX = ({ area, subAreas, showPercentIndexed }) => {

  return (
    <div className='analytics__roll-up-overview-area-pptx'>
      <h3>{area.title}</h3>
      <div className='analytics__roll-up-overview-area-pptx__box'>
        {subAreas.map((subArea, index) => (
          <RollUpOverviewRowPPTX
            key={index}
            title={subArea.title}
            configuredItems={subArea.stats.configuredItems}
            dataRequired={subArea.stats.dataRequired}
            percentIndexed={subArea.stats.percentIndexed}
            dataIndexed={subArea.stats.dataIndexed}
            ciscoDataPerDay={subArea.stats.ciscoDataPerDay}
            nonCiscoDataPerDay={subArea.stats.nonCiscoDataPerDay}
            ciscoDataIndexed={subArea.stats.ciscoDataIndexed}
            nonCiscoDataIndexed={subArea.stats.nonCiscoDataIndexed}
            ciscoPercentIndexed={subArea.stats.ciscoPercentIndexed}
            nonCiscoPercentIndexed={subArea.stats.nonCiscoPercentIndexed}
            showPercentIndexed={showPercentIndexed}
          />
        ))}
      </div>
    </div>
  );
};

RollUpOverviewAreaPPTX.propTypes = {
  area: PropTypes.object.isRequired,
  subAreas: PropTypes.array.isRequired,
  showPercentIndexed: PropTypes.bool.isRequired
};

// ciscoDataPerDay and nonCiscoDataPerDay are forwarded from subArea.stats — no extra selector needed

export default RollUpOverviewAreaPPTX;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/RollUpOverviewAreaPPTX.js